import { render, staticRenderFns } from "./NotificationLeftSidebar.vue?vue&type=template&id=2876d33e&"
import script from "./NotificationLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./NotificationLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports